import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { LatelyImageDb } from '../redux/latelyImageDbSlice';

const useAllLatelyImageDb = (authorId: string | undefined, userId: string | undefined): [string[], LatelyImageDb[]] => {
  const latelyImageDb = useSelector((state: RootState) => state.latelyImageDb);
  let ids: string[];

  if (authorId === userId) {
    ids = Object.keys(latelyImageDb.latelyImages);
  } else {
    ids = Object.keys(latelyImageDb.latelyImages).filter(id => latelyImageDb.latelyImages[id].userId === userId);
  }
  
  const values = ids?.map(id => latelyImageDb.latelyImages[id]);

  return [ids, values];
}

export default useAllLatelyImageDb;
